import styled from "styled-components";
import { fonts } from "styles";

export const Container = styled.section`
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: black;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 616px;
  margin-top: -100px;
`;

export const Title = styled.h2`
  font-family: ${fonts.BentonSansRegular};
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 32px;
  color: white;
`;

export const Text = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 22px;
  color: white;

  p {
    margin-bottom: 32px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Video = styled.div`
  display: flex;
  align-items: center !important;
  width: 100%;
  height: 100vh;
  position: fixed;
  overflow: hidden;
  z-index: 1;
  top: 0;
  left: 0;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.3;
  }
`;
